/* @generated */
import tokens from "../design-tokens/dist/dig/index.module.esm.js";
const { Utilities: _utilities } = tokens;
const utilities = {
  ..._utilities
};
export {
  utilities
};
